import React, { Component } from 'react';

import BlockGraph from '../../StaticRenderer/BlockGraph';

export default class Graph extends Component {
  render() {
    const {
      block,
      className,
      ...otherProps
    } = this.props;

    // leveraging destructuring to omit certain properties from props
    const {
      blockProps, // eslint-disable-line no-unused-vars
      customStyleMap, // eslint-disable-line no-unused-vars
      customStyleFn, // eslint-disable-line no-unused-vars
      decorator, // eslint-disable-line no-unused-vars
      forceSelection, // eslint-disable-line no-unused-vars
      offsetKey, // eslint-disable-line no-unused-vars
      selection, // eslint-disable-line no-unused-vars
      tree, // eslint-disable-line no-unused-vars
      contentState,
      ...elementProps // eslint-disable-line no-unused-vars
    } = otherProps;

    const { src, title } = contentState.getEntity(block.getEntityAt(0)).getData();

    return (
      <div className="draft-js-block draft-js-block-grey draft-js-block-graph">
        <div className="draft-js-container">
          <div className="draft-js-content" onClick={this.props.onClick}>
            <BlockGraph content={{ src, title }}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DraftEditor/GraphPlugin/Graph.js